import { getMergedParamsFromObject } from 'helpers/utils/RequestUtils';
import { post, get, Pagination } from './methods';

export enum PresencaElementTipoPresenca {
  ONLINE = 'ONLINE',
  AGENCIA = 'AGENCIA',
  OFFLINE = 'OFFLINE',
  PRESENCIAL = 'PRESENCIAL',
  BIOMETRIA = 'BIOMETRIA',
}

export enum PresencaElementTipoAssinatura {
  BIOMETRIA = 'BIOMETRIA',
  FISICA = 'FISICA',
}

export interface PresencaElement {
  agencia: string;
  colaborador: string;
  ldapPresencaAgencia: string;
  conta: string;
  coordenador: string;
  cpfCnpj: string;
  dataHoraPresenca: string;
  nomeConvocado: string;
  nucleo: string;
  presencaConfirmadaPor: string;
  tipoPresenca: PresencaElementTipoPresenca;
  tipoAssinatura: PresencaElementTipoAssinatura;
  lengthTime: string | undefined;
}

type PresencaResponse = Pagination<PresencaElement[]>;

export interface PresencaRequest {
  idEvento: number;
  agencias?: Array<string>;
  cpfOrNome?: string;
  nucleos?: Array<string>;
  page?: number;
  size?: number;
}

export enum FlagColaborador {
  NaoColaborador,
  Colaborador,
}

export interface IListaPresencaByEventoCPF {
  cpfCnpjAssociado: string;
  cpfRepresentante: string;
  nomeAssociado: string;
  nomeRepresentante: string;
  numeroConta: string;
  flgColaborador: FlagColaborador;
}

export interface IPresencaByEventoCPF {
  cpfRepresentante: string;
  nomeRepresentante: string;
  listPresencasAgenciaResponse: IListaPresencaByEventoCPF[];
}

const presenca = {
  list: (data: PresencaRequest) => {
    const endpoint = 'presenca/page';
    return post<PresencaResponse>(endpoint, data);
  },
  findByEventoAndCPF: (idEvento: string, cpf: string) => {
    const endpoint = `presenca/tipo-agencia/${idEvento}/${cpf}`;
    return get<IPresencaByEventoCPF>(endpoint);
  },
  listConvidados: (
    idEvento: number,
    page?: number,
    size?: number,
    texto?: string
  ) => {
    const endpoint = `presenca/convidado/?${getMergedParamsFromObject({
      idEvento,
      page,
      size,
      texto,
    })}`;
    return get<PresencaResponse>(endpoint);
  },
};

export default presenca;
